import { ReturnActionType } from "../types/return-type";
import { FilterActionTypes } from "../types/filter";

export const openFilter = (): ReturnActionType => ({ type: FilterActionTypes.FILTER_OPEN });

export const closeFilter = (): ReturnActionType => ({ type: FilterActionTypes.FILTER_CLOSE });
